var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-input',{class:_vm.inputClass,attrs:{"id":_vm.id,"name":_vm.name,"type":"text","value":_vm.displayValue},on:{"input":_vm.onInput,"blur":_vm.onBlur}})
}
var staticRenderFns = []

export { render, staticRenderFns }